<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="()=> scan = !scan">Scan Product</a>
                </span>
                <div class="alert alert-primary" role="alert" v-if="alert">
                    Prodotto Salvato Con successo
                </div>
            </div>
        </div>    
        <div class="cont-scan" v-if="scan" >
            <div class="row-scan">
            <div class="cam">
                <StreamBarcodeReader
                @decode="(a,b,c) => onDecode(a,b,c)"
                @loaded="onLoaded"
                @close="onClose"
                ></StreamBarcodeReader>
            </div>
            <div class="scan">
                <span>
                    <span class="text">Bar Code</span>
                    <!--<span>{{code}}</span>-->
                    <input type="text" v-model="code"/>
                </span>
                <span>
                    <span class="text">Descrizione</span>
                    <input  type="text" v-model="descrizione"/>
                </span>
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="saveProduct">Save Product</a>
                </span>
            </div>
            </div>
        </div> 
    </div>
</template>






<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'MappaturaP',
    components: {
    StreamBarcodeReader,
  },
  data: function () {
            return {
                scan:false,
                text:'',
                id: null,
                descrizione:'',
                code:'',
                prodotti:[],
                alert:false,
                store

            }
   },
  methods: {
    getParams () {
       console.log('Params: ', this.$route.params);
    },
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    onDecode(a, b, c) {
      console.log(a, b, c);
      this.text = a;
      this.code=a;
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
    },
    onLoaded() {
      console.log("load");
    },
    onClose() {
        this.scan = false;
    },
    saveProduct() {
        this.axios.post(this.store.path+ `mappaP`,{code:this.code,descrizio:this.descrizione,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
             if(response.data){
                console.log('Prodotto Mappato')
                this.alert=true;
                setTimeout(() =>{
                    this.alert=false;
                }, 2000);
            }else{console.log('Non è stato possibile Mappare questo Prodotto')}
            })
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
  },
  beforeMount() {
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 15px;
    background-color: #f8f9fa;
}

.nav-sale {
    margin-bottom: 20px;
}

.con-sal {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    align-items: center;
}

.cam {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.row-scan {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

.scan {
    width: 100%;
    max-width: 400px;
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.scan input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
    box-sizing: border-box;
}

@media (max-width: 600px) {
    .cam {
        max-width: 100%;
    }
}
</style>